define('views/content/distributor_licenses',['require','views/base/list_page_view','views/components/distributor_product/distributor_products','collections/distributor_products','views/components/purchase_information/purchase_information','text!templates/content/distributor_licenses.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var DistributorProductsView = require('views/components/distributor_product/distributor_products');
    var DistributorProductsCollection = require('collections/distributor_products');

    var PurchaseInformationView = require('views/components/purchase_information/purchase_information');
    
    var temp = require("text!templates/content/distributor_licenses.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'reseller-licenses-page',
        titleKey: 'licenses',

        setCollection: function () {
            this.collection = new DistributorProductsCollection();
        },

        regions: function(){
            return {
                ListContainer: ".main-list-container",
                PurchaseInformationContainer: ".purchase-information-container"
            };
        },

        onRender: function() {
            this.ListContainer.show(new DistributorProductsView({
                collection: this.collection
            }));

            this.PurchaseInformationContainer.show(new PurchaseInformationView());

        }

    });
});
